var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonTeams = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M19.006 13.017a5.016 5.016 0 1110.033 0 5.016 5.016 0 11-10.033 0z", fill: fills.dark }),
        React.createElement("path", { d: "M17.648 21.66a5.451 5.451 0 013.854-1.595h5.043c1.445 0 2.832.575 3.853 1.596a5.455 5.455 0 011.595 3.855V38a2.183 2.183 0 01-2.183 2.184H18.237A2.183 2.183 0 0116.054 38V25.516a5.44 5.44 0 011.595-3.855zM5.052 23.106a3.589 3.589 0 012.538-1.052h2.827a3.589 3.589 0 013.59 3.591v9.079a1.44 1.44 0 01-1.44 1.44H5.44A1.44 1.44 0 014 34.724v-9.079c0-.953.379-1.866 1.052-2.54zM35.044 23.106a3.589 3.589 0 012.539-1.052h2.827A3.589 3.589 0 0144 25.645v8.915A1.44 1.44 0 0142.56 36h-7.13a1.44 1.44 0 01-1.44-1.44v-8.915a3.604 3.604 0 011.054-2.54z", fill: fills.light }),
        React.createElement("path", { d: "M34.997 15.957a4 4 0 117.999 0 4 4 0 11-7.999 0zM5.005 15.957a4 4 0 117.998 0 4 4 0 11-7.998 0z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
